import Button from 'components/Button'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
export const MainDiv = styled(Flex)`
 display: flex;
  align-items: center;
  justify-content: space-between; /
width: 100%;
height:63px;
  border: #d8ddff 2px solid;
  border-radius: 10px;
  flex-direction: row;
  // padding-bottom: 20px;
  // padding-right: 20px;
  background-color: ${({ variant }) => {
    switch (variant) {
      case 'primary':
        return '#B6BDFF40'
      case 'secondary':
        return '#FFB6C140'
      case 'tertiary':
        return '#C1FFC140'
      default:
        return '#02457A33'
    }
  }};
  border-color: ${({ variant }) => {
    switch (variant) {
      case 'primary':
        return '#d8ddff'
      case 'secondary':
        return '#ffb6c1'
      case 'tertiary':
        return '#c1ffc1'
      default:
        return '#d8ddff'
    }
  }};

  margin-top: -8px;
  margin-bottom: 20px;

  ;
`
export const TimeDiv = styled(Flex)`
 display: flex;
  align-items: center;
  justify-content: space-between; /
width: 100%;
height:101px;
  border: #d8ddff 2px solid;
  border-radius: 10px;
  flex-direction: row;
  padding-bottom: 20px;
  padding-right: 20px;
  background-color: ${({ variant }) => {
    switch (variant) {
      case 'primary':
        return '#B6BDFF40'
      case 'secondary':
        return '#FFB6C140'
      case 'tertiary':
        return '#C1FFC140'
      default:
        return '#02457A33'
    }
  }};
  border-color: ${({ variant }) => {
    switch (variant) {
      case 'primary':
        return '#d8ddff'
      case 'secondary':
        return '#ffb6c1'
      case 'tertiary':
        return '#c1ffc1'
      default:
        return '#d8ddff'
    }
  }};

  margin-top: -8px;
  margin-bottom: 20px;
  

  ;
`

export const StyledText = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
  color: ${props => props.color || '#717171'};
  margin-top: 15px;
  width: 192px;
`
export const DynamicPart = styled.span`
  font-family: ${props => props.fontFamily || 'inherit'};
`

export const Duration = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
  text-align: left;
  color: ${props => props.color || 'black'};
  padding: 36px 56px 20px 38px;
  display: flex;
  width: 192px;
`

export const VerticalDivider = styled.div`
  height: 28px;
  border-left: 1.3px solid #02457a;
  margin-top: 15px;
  display: ${props => (props.show ? 'block' : 'none')};
`
export const VerticalDivider1 = styled.div`
  height: 41px;
  border-left: 1.3px solid #02457a;
  margin-top: 15px;
  display: ${props => (props.show ? 'block' : 'none')};
`

export const StyledText1 = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
  text-align: left;
  padding: 27px 7px 11px 35px;
  width: 405px;
`

export const Container = styled.div`

  gap: 10px
  margin-top:-20px;
  width: 100%;
`
export const StyledText2 = styled.span`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
  padding-top: 16px;
  margin-right: 93px;
`
export const Part1 = styled.span`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
`

export const Part2 = styled.span`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
`
export const DateDisplay = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  padding: 10px;
`

export const Date2 = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  padding: 10px;
  margin-left: -175px;
  margin-top: 39px;
  width: 161px;
`
export const Date1 = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
  padding: 10px;
  margin-left: -175px;
  margin-top: 39px;
  width: 161px;
`
export const HorizontalLine = styled.hr`
  border: none;
  border-top: 1px solid #ccc; // Customize the border color
  margin: 20px 0; // Customize the margin
  width: 100%; // Customize the width
  margin-bottom: 0;
`

export const Regenddate = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: ${props => props.color || '#717171'};
  padding: 20px;
  padding-left: 43px;
  padding-right: 56px;
`
export const Location = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: ${props => props.color || '#717171'};
  padding: 20px;
  padding-left: 81px;
  padding-right: 56px;
`

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const IconsWrapper = styled.div`
  display: flex;
  gap: 10px;
`

export const Icon = styled.div`
  cursor: pointer;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px; // Set the width to an appropriate size
  height: 40px; // Set the height to an appropriate size
  border: none;
  border-radius: 5px;
  margin-top: 17px;
`

export const StatusButton = styled(Button.Primary)`
  font-size: 14px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  padding: 6px 5px 6px 5px;
  border-radius: 10px;
  font-weight: 600;
  margin-left: ${props => (props?.mLeft ? props?.mLeft : 'auto')};
  // width: 106px;
  height: 35px;
  text-align: center;
  width: auto;
  min-width: 120px;


  ${({ status }) => {
    switch (status) {
      case 'viewDetails':
        return `
          background-color: #FBFAFF;
          color: ${COLORS.PRIMARY};
           :hover {
            background: #FBFAFF;
            color: ${COLORS.PRIMARY};
          }
            :focus{
            background: #FBFAFF;
            color: ${COLORS.PRIMARY};
            }
        `
      case 'error':
        return `
          background-color: red;
          color: white;
        `
      case 'register':
        return `
          background-color: rgba(50, 73, 215, 1);
          color: #fff;
           :hover {
            background: rgba(50, 73, 215, 1);
            color: #fff;
          }
             :focus{
            background: rgba(50, 73, 215, 1);
            color: #fff;
            }
        `
      case 'cancel':
        return `
            background-color: #FBFAFF;
            color: ${COLORS.PRIMARY};
             :hover {
              background: #FBFAFF;
              color: ${COLORS.PRIMARY};
            }
              :focus{
              background: #FBFAFF;
              color: ${COLORS.PRIMARY};
              }
          `
      default:
        return `
            background-color: rgba(50, 73, 215, 1);
          color: #fff;
           :hover {
            background: rgba(50, 73, 215, 1);
            color: #fff;
          }
             :focus{
            background: rgba(50, 73, 215, 1);
            color: #fff;
            }
        `
    }
  }}
`
export const EventStatusCard = styled(Flex)`
  align-items: center;
  width: ${props => (props.width ? props.width : '100%')};
  padding: ${props => (props.padding ? props.padding : '10px 30px')};
  // background: ${props => props.styleBasedObj?.bgColor};
  // border: 1px solid ${props => props.styleBasedObj?.borderColor};
  border: 1px solid ${props => props.borderColor};
  background-color: ${props => props.backgroundColor};
  color: ${props => props.textColor};
  border-radius: 10px;
  // opacity: 0.7;
  margin: auto;
  margin-top: ${props => props?.mTop};
  margin-bottom: ${props => props?.mBottom};
`

export const EventText = styled(Flex)`
  color: #717171;
  font-size: 12px;
  font-weight: 400;
  width: 100px;
  position: relative;
  display: flex;
  align-items: center;
`

export const EventDay = styled(Flex)`
color: ${props => (props.allDayEvent ? '#717171' : '#000000')};
font-size: ${props => (props.allDayEvent ? '12px' : '18px')};
font-weight: ${props => (props.allDayEvent ? '400' : '700')};
margin: ${props => (props.allDayEvent ? '' : '10px')}
`

export const VerticalLine = styled.div`
  height: 40px;
  border-left: 1.3px solid ${props => props.borderColor};
  position: absolute;
  right: 0;
  display: ${props => (props.show ? 'block' : 'none')};
`

export const EventTitleSection = styled.div`
  width: ${props => (props.customWidth ? props?.customWidth : '320px')};
  padding-left: 30px;
  position: relative;
  display: flex;
  align-items: center;
`

export const EventTitle = styled.div`
  color: #000000;
  font-size: 20px;
  font-weight: 700;
  width: ${props =>
    props?.isWidth ? '250px' : props.ellipse ? '150px' : 'unset'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ${props => (props.ellipse ? 'ellipsis' : 'unset')};
  text-transform: capitalize;

`

export const EventCategory = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #000000;
`

export const EventHeading = styled.div`
  color: #717171;
  font-size: 12px;
  font-weight: 400;
`
export const EventAnswer = styled.div`
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;

`
export const DynamicText = styled.div`
  color: #000000;
  font-size: ${props => (props?.size ? props?.size : '14px')};
  font-weight: ${props => (props?.fontWeight ? props?.fontWeight : 400)};
`

export const EventExpiry = styled.div`
  color: rgba(62, 62, 62, 1);
  font-size: 12px;
  font-weight: 700;
  margin-left: auto;
`

export const EmptyStateContainer = styled.div`
  height: 45vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: gray;
  flex-direction: column;
`

export const CompletedText = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-weight: 400;
  color: rgba(113, 113, 113, 1);
`
